import { render } from "./imagenSegunda_ingles.vue?vue&type=template&id=2594869e&scoped=true"
import script from "./imagenSegunda_ingles.vue?vue&type=script&lang=js"
export * from "./imagenSegunda_ingles.vue?vue&type=script&lang=js"

import "./imagenSegunda_ingles.vue?vue&type=style&index=0&id=2594869e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2594869e"]])

export default __exports__